export const getIntercomConversationURL = ({
  dataCenter = 'us',
  appID,
  conversationID,
}: {
  dataCenter?: 'us' | 'eu' | 'au';
  appID: string;
  conversationID: string;
}) => {
  const domainMap = {
    us: 'https://app.intercom.com',
    eu: 'https://app.eu.intercom.com',
    au: 'https://app.au.intercom.com',
  };

  const domain = domainMap[dataCenter] ?? domainMap.us;

  return `${domain}/a/apps/${appID}/conversations/${conversationID}`;
};
